import { SubstrateSearchResponse } from 'owa-search-service';
import { action } from 'satcheljs';

const onAnswerReceived = action('onAnswerReceived', (answerResponse: SubstrateSearchResponse) => ({
    answerResponse,
}));

export default onAnswerReceived;
